import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const { t } = useLang();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { setStatus("error"); return; }
      if (attempts < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [params, refresh]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-4">
      {status === "checking" && (<><Loader2 className="w-10 h-10 text-emerald-400 animate-spin" /><p data-testid="payment-checking" className="text-slate-400">{t("checking_payment")}</p></>)}
      {status === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 text-emerald-400" />
          <h1 data-testid="payment-success-title" className="font-heading text-3xl font-extrabold text-white">{t("payment_ok")}</h1>
          <p className="text-slate-400">{t("payment_ok_sub")}</p>
          <Link to="/dashboard" data-testid="payment-goto-dashboard" className="mt-4 bg-emerald-500 hover:bg-emerald-400 text-black font-medium px-6 py-3 text-sm transition-colors">{t("go_dashboard")}</Link>
        </>
      )}
      {(status === "error" || status === "timeout") && (
        <>
          <XCircle className="w-14 h-14 text-red-400" />
          <h1 data-testid="payment-error-title" className="font-heading text-3xl font-extrabold text-white">{t("payment_ko")}</h1>
          <Link to="/pricing" className="text-emerald-400 hover:underline text-sm">{t("nav_pricing")}</Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4 px-4">
      <XCircle className="w-14 h-14 text-amber-400" />
      <h1 data-testid="payment-cancel-title" className="font-heading text-3xl font-extrabold text-white">{t("payment_ko")}</h1>
      <p className="text-slate-400">{t("payment_ko_sub")}</p>
      <Link to="/pricing" data-testid="payment-back-pricing" className="mt-2 text-emerald-400 hover:underline text-sm">{t("nav_pricing")}</Link>
    </div>
  );
}
